import type { TransformObjectOp } from "./canvas-op";
import type { CanvasObject } from "./canvas-object";

/**
 * `object.transform` の変更内容をキャンバスオブジェクトへ反映する。
 *
 * サーバ権威の適用、クライアントの楽観適用、REST 更新で同じ結果を導くための共有実装。
 * `manualHeight` はテキストだけに反映し、他の種別へ未知の属性として残さない。
 */
export function applyObjectTransform(
  current: CanvasObject,
  transform: TransformObjectOp["transform"]
): CanvasObject {
  const { manualHeight, ...commonTransform } = transform;
  const effectiveTransform =
    current.type === "text" && manualHeight !== undefined
      ? { ...commonTransform, manualHeight }
      : commonTransform;

  if (current.type !== "pen-stroke") {
    return { ...current, ...effectiveTransform } as CanvasObject;
  }

  const nextX = effectiveTransform.x ?? current.x;
  const nextY = effectiveTransform.y ?? current.y;
  const dx = nextX - current.x;
  const dy = nextY - current.y;

  // ペンストロークの points は stage 座標で保持するため、
  // オブジェクト移動時は外接矩形と同じ差分だけポイント群も移動する。
  return {
    ...current,
    ...effectiveTransform,
    points:
      dx === 0 && dy === 0
        ? current.points
        : current.points.map((point) => ({ ...point, x: point.x + dx, y: point.y + dy })),
  };
}
